module.exports = __webpack_public_path__ + "img/logo.572eb6b8.svg";